import { render, staticRenderFns } from "./PatientTableRow.vue?vue&type=template&id=2e2b32ae&"
import script from "./PatientTableRow.vue?vue&type=script&lang=js&"
export * from "./PatientTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports